export default "__VITE_ASSET__Bq0qY7rT__"